<template lang="pug">
    div.paymentInformationWrapper
        div.paymentInformation
            v-container
                v-layout(raw wrap)
                    v-flex(xs12)

                        // Logo
                        logo-component(type="auth")

                        // Horizontal line
                        separator-component.color

                        // Title
                        title-component(:title="$t('payments.payment.title')")

                        // Message
                        div.paymentInformationMessage {{ $t('payments.payment.message') }}

            // Payment form
            payment-form

            v-container
                v-layout(raw wrap)
                    v-flex(xs12)

                        // Horizontal line
                        separator-component.color

                        // Payment information footer
                        div.paymentInformationFooter
                            img(src="https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/payments/stripe.png")

                            div.mt-2(v-html="$t('payments.payment.footerText')")
</template>

<script>
    import Logo from '~components/Logo';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import PaymentForm from './PaymentForm';
    import { isAndroid } from '~services';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            PaymentForm,
            LogoComponent: Logo,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        computed: {
            ...mapGetters('auth', ['notAllowToSubscribe'])
        },
        mounted() {
            // Play Payments policy: the Stripe checkout must never be
            // reachable in the Android app, even via deep link.
            if (this.notAllowToSubscribe || isAndroid()) {
                this.$router.push({ name: 'dashboard.themes' });
            }
        }
    };
</script>

<style lang="stylus" scoped>

    .paymentInformationWrapper
        height: 100%
        display: flex
        align-items: center
        justify-content: center

    .paymentInformation
        width: 100%
        max-width: 520px

    .paymentInformationMessage
        font-size: 12px

    .paymentInformationFooter
        display: flex
        align-items: center
        flex-direction: column
        font-size: 12px
        text-align: center
</style>
